import React from "react";
import styled from "styled-components";
import { Size } from "@themes/Device";

const HideOnMobile = styled.div`
    display: flex;

    @media (max-width: ${Size.tabletS}) {
        display: none;
    }
`;

interface HideOnMobileScreenSizesProps {
    children: JSX.Element;
}
export default function HideOnMobileScreenSizes(props: HideOnMobileScreenSizesProps) {
    return <HideOnMobile>{props.children}</HideOnMobile>;
}
